import React from 'react';
import {Platform} from 'react-native';

import MetricSection from '/component/partial/MetricSection';
import {MetricsSection} from '/constant/TestIDs';

import {useNeedAttentionSection} from './NeedAttentionSection.hook';
import {NeedAttentionSectionProps} from './NeedAttentionSection.types';

export const NeedAttentionSection = ({
  expiringCoachRenewal = 0,
  notCertified = 0,
  onShowReport = () => {},
  onShowInfoPopover = () => {},
}: NeedAttentionSectionProps) => {
  const containerStyle = Platform.OS === 'web' ? {marginBottom: 8} : undefined;
  const {onInfoPress, onItemPress, listItems, ts} = useNeedAttentionSection({
    expiringCoachRenewal,
    notCertified,
    onShowReport,
    onShowInfoPopover,
  });

  return (
    <MetricSection
      analyticsTitle="Need Attention"
      infoAccessibilityLabel={ts(
        'accessibilityLabel',
        'Need Attention Section Information',
      )}
      testID={MetricsSection.metricSectionNeedAttention}
      title={ts('heading', 'Need Attention')}
      listItems={listItems}
      onInfoPress={onInfoPress}
      onItemPress={onItemPress}
      containerStyle={containerStyle}
    />
  );
};

export default NeedAttentionSection;
